import React from 'react';
import { PersonalInformationSection, ThemeSection } from '@/components/account';

const ProfileMainContent = () => {
  return (
    <>
      <PersonalInformationSection />
      <ThemeSection />
      {/* EmailSection and PasswordSection temporarily removed - non-functional */}
    </>
  );
};

export default ProfileMainContent;
